import "./vendorPage.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import newRequest from "../../context/newRequest";
import useVendors from "../../hooks/useVendors";

const VendorPage = () => {
  const { vendors, loading, refreshVendors } = useVendors();
  const [vendorId, setVendorId] = useState("");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [searchQuery, setSearchQuery] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!vendorId.trim()) {
      setMessage({ type: "error", text: "Vendor ID / Nama tidak boleh kosong!" });
      return;
    }

    setSubmitting(true);
    setMessage({ type: "", text: "" });

    try {
      const res = await newRequest.post("/vendors", {
        id: vendorId.trim(),
        description: description.trim(),
      });

      if (res.status === 200 || res.status === 201) {
        setMessage({ type: "success", text: `Vendor "${vendorId}" berhasil ditambahkan!` });
        setVendorId("");
        setDescription("");
        await refreshVendors();
      }
    } catch (err) {
      const errMsg =
        (err.response && err.response.data && err.response.data.errors) ||
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        "Gagal menambahkan vendor";
      setMessage({ type: "error", text: errMsg });
    } finally {
      setSubmitting(false);
    }
  };

  const filteredVendors = vendors.filter((v) => {
    const q = searchQuery.toLowerCase();
    return (
      (v.id && v.id.toLowerCase().includes(q)) ||
      (v.description && v.description.toLowerCase().includes(q))
    );
  });

  return (
    <div className="vendorPage">
      <Sidebar />
      <div className="vendorContainer">
        <Navbar />

        <div className="topSection">
          <h1>Manajemen Vendor</h1>
          <p className="subtitle">
            Buat dan kelola vendor penyedia jaringan / fiber optic. Setiap vendor yang ditambahkan akan otomatis muncul di seluruh dropdown pilihan vendor tiket.
          </p>
        </div>

        <div className="contentGrid">
          <div className="card formCard">
            <h2>Tambah Vendor Baru</h2>
            <form onSubmit={handleSubmit}>
              <div className="inputGroup">
                <label htmlFor="vendorId">Vendor ID / Nama *</label>
                <input
                  id="vendorId"
                  type="text"
                  placeholder="Contoh: LINTASARTA"
                  value={vendorId}
                  onChange={(e) => setVendorId(e.target.value)}
                  required
                />
              </div>

              <div className="inputGroup">
                <label htmlFor="vendorDesc">Deskripsi Vendor</label>
                <textarea
                  id="vendorDesc"
                  rows="3"
                  placeholder="Keterangan singkat mengenai vendor..."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>

              <button type="submit" disabled={submitting} className="submitBtn">
                {submitting ? "Menyimpan..." : "Simpan Vendor"}
              </button>

              {message.text && (
                <div className={`statusMsg ${message.type}`}>
                  {message.text}
                </div>
              )}
            </form>
          </div>

          <div className="card tableCard">
            <div className="tableHeader">
              <h2>Daftar Vendor ({vendors.length})</h2>
              <input
                type="text"
                placeholder="Cari vendor..."
                className="tableSearch"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="tableWrapper">
              {loading && <p className="loadingText">Memuat data vendor...</p>}
              <table className="vendorTable">
                <thead>
                  <tr>
                    <th style={{ width: "40px" }}>No</th>
                    <th>Vendor ID / Nama</th>
                    <th>Deskripsi</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredVendors.length === 0 ? (
                    <tr>
                      <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                        Tidak ada vendor yang sesuai pencarian
                      </td>
                    </tr>
                  ) : (
                    filteredVendors.map((v, idx) => (
                      <tr key={v.id || idx}>
                        <td>{idx + 1}</td>
                        <td className="vendorIdCell">
                          <strong>{v.id}</strong>
                        </td>
                        <td className="descCell">{v.description || "-"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorPage;
